import React from 'react'
import { Avatar } from "n2-styles";

const PrepressExtraCopyItem = ({ order }) => {
  const firstPublication = order.publications[0]
  const publicationPhrase = order.publications.length === 1 ?
                              null :
                              `+${order.publications.length - 1}`
  return (
    <a className="list-group-item u-hover--raised" href={order.href}>
      <div className="d-flex w-100 align-items-center cursor-pointer row">
        <div className={"list-status-side-bar"} title={order.status}></div>
        <div className="d-flex flex-column align-content-center mx-3">
          {order.avatar && <Avatar user={order.avatar} />}
        </div>

        <div className="d-flex flex-column col-5 col-sm-3">
          {order.name}
          <small className="grey-text">{order.territory_name}</small>
        </div>

        <div className="d-none d-sm-flex flex-column col u-wrap">
          <small className="grey-text">{firstPublication}</small>
          <small className="grey-text">{publicationPhrase}</small>
        </div>

        <div className="d-none d-sm-flex flex-column col u-wrap">
          <small className="grey-text">{order.copies} Copies</small>
        </div>

        <div className="d-none d-lg-flex flex-column grey-text col-2 u-wrap">
          <small className="grey-text">{order.formatted_modified_at}</small>
        </div>

        <div className="d-flex grey-text flex-column col-1 align-items-center ml-auto">
          <i className="material-icons">keyboard_arrow_right</i>
        </div>
      </div>
    </a>
  )
}

export default PrepressExtraCopyItem
